import { useState, useEffect, useCallback } from "react";

const KEY = "kelifa_favs";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export const useFavorites = () => {
  const [favs, setFavs] = useState(read);

  useEffect(() => {
    const sync = () => setFavs(read());
    window.addEventListener("kelifa-favs", sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener("kelifa-favs", sync); window.removeEventListener("storage", sync); };
  }, []);

  const toggle = useCallback((id) => {
    const cur = read();
    const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
    localStorage.setItem(KEY, JSON.stringify(next));
    setFavs(next);
    window.dispatchEvent(new Event("kelifa-favs"));
  }, []);

  const isFav = useCallback((id) => favs.includes(id), [favs]);
  return { favs, toggle, isFav };
};
